/* eslint-disable max-len, padded-blocks, prefer-destructuring */
export default {
  computed: {
    myActiveProjectsTotal() {
      if (!this.myActiveProjects || this.myActiveProjects === null) return 0;
      return this.myActiveProjects.length;
    },
    projectsPendingApprovalTotal() {
      if (!this.projectsPendingApproval || this.projectsPendingApproval === null) return 0;
      return this.projectsPendingApproval.length;
    },
    siteAssessmentsPendingApprovalTotal() {
      if (!this.siteAssessmentsPendingApproval || this.siteAssessmentsPendingApproval === null) return 0;
      return this.siteAssessmentsPendingApproval.length;
    },
    workorderBillsPendingApprovalTotal() {
      if (!this.workorderBillsPendingApproval || this.workorderBillsPendingApproval === null) return 0;
      return this.workorderBillsPendingApproval.length;
    },
  },
  data: () => ({
    myActiveProjectsFields: [
      {
        key: 'projectName',
        label: 'Project Name',
        sortable: true,
      },
      {
        key: 'approvalStatus',
        label: 'Approval Status',
        sortable: true,
      },
      {
        key: 'category',
        label: 'Category',
        sortable: true,
      },
      {
        key: 'startDate',
        label: 'Start Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
      {
        key: 'endDate',
        label: 'End Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
      {
        key: 'annualBudget',
        label: 'Annual Budget',
        sortable: true,
        class: 'text-right currency-column',
      },
      {
        key: 'fundsSpent',
        label: 'Funds Spent',
        sortable: true,
        class: 'text-right currency-column',
      },
      {
        key: 'fundsRemaining',
        label: 'Funds Remaining',
        sortable: true,
        class: 'text-right currency-column',
      },
      {
        key: 'nextActivityDate',
        label: 'Date of Next Activity',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
    ],
    myActiveProjectsLoading: true,
    myActiveProjectsSortBy: 'projectName',
    myActiveProjectsSortDesc: false,
    pendingBudgetFields: [
      {
        key: 'annualBudgetYear',
        label: 'Annual Budget Year',
        sortable: true,
        class: 'total-column',
      },
      {
        key: 'projectName',
        label: 'Project Name',
        sortable: true,
      },
      {
        key: 'category',
        label: 'Category',
        sortable: true,
      },
      {
        key: 'projectManager',
        label: 'Project Mgr',
        formatter: (value) => {
          if (value === null) return '';
          return `${value.firstName} ${value.lastName}`;
        },
        sortable: true,
      },
      {
        key: 'submittedDate',
        label: 'Submitted Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
        class: 'date-column',
      },
      {
        key: 'annualBudgetTotal',
        label: 'Annual Budget Total',
        sortable: true,
        class: 'text-right total-column',
      },
    ],
    pendingBudgetsAreLoading: true,
    pendingBudgetsSortBy: 'submittedDate',
    pendingBudgetsSortDesc: false,
    projectsPendingApprovalFields: [
      {
        key: 'projectName',
        label: 'Project Name',
        sortable: true,
      },
      {
        key: 'category',
        label: 'Category',
        sortable: true,
      },
      {
        key: 'approvalStatus',
        label: 'Approval Status',
        sortable: true,
      },
      {
        key: 'projectManager',
        label: 'Project Mgr',
        formatter: (value) => {
          if (value === null) return '';
          return `${value.firstName} ${value.lastName}`;
        },
        sortable: true,
      },
      {
        key: 'approvalDate',
        label: 'Submitted Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
      {
        key: 'rankingScore',
        label: 'Score',
        sortable: true,
        class: 'text-right number-column',
      },
    ],
    projectsPendingApprovalLoading: true,
    projectsPendingApprovalSortBy: 'approvalDate',
    projectsPendingApprovalSortDesc: false,
    selectedPanel: '',
    siteAssessmentsPendingApprovalFields: [
      {
        key: 'siteName',
        label: 'Site Name',
        sortable: true,
      },
      {
        key: 'preparer',
        label: 'Preparer',
        sortable: true,
      },
      {
        key: 'preparedDate',
        label: 'Prepared Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
      {
        key: 'subWatershed',
        label: 'Subwatershed',
        sortable: true,
      },
    ],
    siteAssessmentsPendingApprovalLoading: true,
    siteAssessmentsPendingApprovalSortBy: 'preparedDate',
    siteAssessmentsPendingApprovalSortDesc: false,
    workorderBillsPendingApprovalFields: [
      {
        key: 'billIdentifier',
        label: 'Invoice Number',
        sortable: true,
      },
      {
        key: 'projectName',
        label: 'Project Name',
        sortable: true,
      },
      {
        key: 'projectManagerName',
        label: 'Project Manager Name',
        sortable: true,
      },
      {
        key: 'workOrderId',
        label: 'Work Order Number',
        sortable: true,
      },
      {
        key: 'workOrderVendor',
        label: 'Work Order Vendor',
        sortable: true,
      },
      {
        key: 'receivedDate',
        label: 'Received Date',
        formatter: (value) => {
          if (!value || value === null) return '';
          return new Date(value).toLocaleDateString();
        },
        sortable: true,
        sortByFormatted: false,
      },
      {
        key: 'status',
        label: 'Status',
        sortable: true,
      },
    ],
    workorderBillsPendingApprovalLoading: true,
    workorderBillsPendingApprovalSortBy: 'projectManagerName',
    workorderBillsPendingApprovalSortDesc: false,
  }),
  methods: {
    isSelectedPanel(panel) {
      return this.selectedPanel === panel;
    },
    async loadMyActiveProjects() {
      this.myActiveProjectsLoading = true;

      await this.$store.dispatch('Project/getMyActiveProjects');

      this.myActiveProjects.forEach((e) => {

        e.annualBudget = 0;
        e.fundsSpent = 0;
        e.fundsRemaining = 0;
        e.projectWorkOrders = e.projectWorkOrders ?? [];
        e.projectWorkOrderBills = e.projectWorkOrderBills ?? [];

        if (e.projectBudget && e.projectBudget != null) {
          if (e.projectBudget.projectBudgetYears && e.projectBudget.projectBudgetYears != null) {
            const fiscalYearBudget = e.projectBudget.projectBudgetYears.find((budgetYear) => budgetYear.year === this.fiscalYear);
            if (fiscalYearBudget && fiscalYearBudget != null) {
              e.annualBudget = this.getYearSubtotal(fiscalYearBudget);
              e.annualBudget += this.getContingencyAmount(fiscalYearBudget);
              e.annualBudget += this.getAnnualIncreaseAmount(fiscalYearBudget);
            }
          }
        }

        const workOrders = e.projectWorkOrders.filter(
          (workOrder) => (this.fiscalYearStart <= new Date(workOrder.requestedDate))
            && (new Date(workOrder.requestedDate) < this.fiscalYearEnd),
        );

        const workOrderIds = workOrders.map((workOrder) => workOrder.id);

        const workOrderBills = e.projectWorkOrderBills.filter(
          (projectWorkOrderBill) => workOrderIds.includes(projectWorkOrderBill.workOrderId)
            && projectWorkOrderBill.status === this.config.workOrderBillForm.submitStatus.Paid,
        );

        const workOrderTotals = workOrderBills.map(
          (workOrderBill) => workOrderBill.workOrderBillLineItems,
        ).flat().map(
          (workOrderBillLineItem) => (workOrderBillLineItem.quantity * workOrderBillLineItem.salePrice),
        );

        if (workOrderTotals && workOrderTotals.length > 0) {
          e.fundsSpent = workOrderTotals.reduce((a, b) => a + b);
        }

        e.fundsRemaining = (e.annualBudget - e.fundsSpent);

        if (e.startDate != null) {
          e.startDate = new Date(e.startDate);
        }

        if (e.endDate != null) {
          e.endDate = new Date(e.endDate);
        }

        if (e.nextActivityDate != null) {
          e.nextActivityDate = new Date(e.nextActivityDate);
        }

      });

      this.myActiveProjectsLoading = false;
    },
    async loadProjectsPendingApproval() {
      this.projectsPendingApprovalLoading = true;
      await this.$store.dispatch('Project/getProjectsPendingApproval');
      this.projectsPendingApproval.forEach((e) => {
        if (e.approvalDate != null) {
          e.approvalDate = new Date(e.approvalDate);
        }
      });
      this.projectsPendingApprovalLoading = false;
    },
    async loadSiteAssessmentsPendingApproval() {
      this.siteAssessmentsPendingApprovalLoading = true;
      await this.$store.dispatch('SiteAssessment/getSiteAssessmentsPendingApproval');
      await this.$store.dispatch('SiteAssessment/fetchTualatinContacts');
      const vm = this;
      this.siteAssessmentsPendingApproval.forEach((e) => {
        if (e.background && e.background != null) {
          const contact = vm.tualatinContacts
            .find((cntct) => cntct.contacT_ID === e.background.preparerId);
          if (contact) {
            e.preparer = `${contact.firsT_NAME} ${contact.lasT_NAME}`;
          } else {
            e.preparer = '';
          }
          e.preparedDate = e.background.preparedDate;
          if (e.preparedDate != null) {
            e.preparedDate = new Date(e.preparedDate);
          }
        }
        e.siteName = 'N/A';
        e.subWatershed = 'N/A';
        if (e.site) {
          e.siteName = e.site.RecordName;
          e.subWatershed = e.site.Subwatershed_Name__c;
        }
      });
      this.siteAssessmentsPendingApprovalLoading = false;
    },
    async loadPendingBudgets() {
      this.pendingBudgetsAreLoading = true;
      await this.$store.dispatch('Project/fetchPendingBudgets');
      this.pendingBudgetsAreLoading = false;
    },
    async loadWorkorderBillsPendingApproval() {
      this.workorderBillsPendingApprovalLoading = true;
      await this.$store.dispatch('WorkorderBill/getWorkorderBillsPendingApproval');
      this.workorderBillsPendingApproval.forEach((e) => {
        if (e.project && e.project != null) {
          e.projectName = e.project.projectName;
        } else {
          /* eslint-disable-next-line */
          console.warn (`Bill entity's 'project' property is undefined or null: Bill Id: ${e.id}, Project Id: ${e.projectId}`);
          e.projectName = '#Error';
        }
        e.projectManagerName = '';
        if (e.projectManager && e.projectManager != null) {
          e.projectManagerName = `${e.projectManager.firstName} ${e.projectManager.lastName}`;
        }
        e.workOrderId = '';
        e.workOrderNumber = '';
        e.workOrderVendor = '';
        if (e.workOrder && e.workOrder != null) {
          const workOrder = e.workOrder;
          e.workOrderId = workOrder.id;
          e.workOrderNumber = workOrder.workOrderNumber;
          if (workOrder.vendorContact && workOrder.vendorContact != null) {
            e.workOrderVendor = `${workOrder.vendorContact.firstName} ${workOrder.vendorContact.lastName}`;
          } else if (workOrder.vendorOrganization && workOrder.vendorOrganization != null) {
            e.workOrderVendor = workOrder.vendorOrganization.name;
          }
        }
        if (e.receivedDate != null) {
          e.receivedDate = new Date(e.receivedDate);
        }
      });
      this.workorderBillsPendingApprovalLoading = false;
    },
    onDashboardPanelClick(selectedPanel) {
      this.selectedPanel = selectedPanel;
    },
  },
};
